var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 9.90514V11.2499C1.375 11.3493 1.41451 11.4447 1.48484 11.5151C1.55516 11.5854 1.65054 11.6249 1.75 11.6249H3.09475C3.19401 11.6249 3.28922 11.5855 3.3595 11.5154L9.7345 5.14039L7.8595 3.26539L1.4845 9.64039C1.4144 9.71067 1.37502 9.80587 1.375 9.90514ZM9.3175 1.80739L11.1925 3.68239L12.0948 2.78014C12.2354 2.63949 12.3143 2.44876 12.3143 2.24989C12.3143 2.05101 12.2354 1.86028 12.0948 1.71964L11.2803 0.905136C11.1396 0.764533 10.9489 0.685547 10.75 0.685547C10.5511 0.685547 10.3604 0.764533 10.2198 0.905136L9.3175 1.80739Z",
    stroke: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ef8a1f83e7b9392ef8bd1013d47e9ad7.svg";
export { ForwardRef as ReactComponent };